class Legajo{
    /**
     * 
     * @param {*} id 
     * @param {*} numero 
     * @param {*} institucion_id 
     * @param {*} persona_id 
     * @param {*} categoria_id 
     * @param {*} seccion_id 
     * @param {*} cargo_id 
     * @param {*} clase 
     * @param {*} personal_temporario 
     * @param {*} discapacidad 
     * @param {*} situacion_revista_id 
     * @param {*} fecha_ingreso 
     * @param {*} fecha_egreso 
     * @param {*} sindicato_id 
     * @param {*} regimen_jubilatorio_id 
     * @param {*} obra_social_id 
     * @param {*} modalidad_contratacion_id 
     * @param {*} forma_pago 
     * @param {*} banco 
     * @param {*} lugar_trabajo 
     * @param {*} lugar_pago 
     * @param {*} aporta_minimo 
     */
    constructor(id, numero, institucion_id, persona_id, categoria_id, seccion_id, cargo_id, clase, personal_temporario, discapacidad, situacion_revista_id, fecha_ingreso, fecha_egreso, sindicato_id, regimen_jubilatorio_id, obra_social_id, modalidad_contratacion_id, forma_pago, banco, lugar_trabajo, lugar_pago, aporta_minimo){
        this.id = id;
        this.numero = numero;
        this.institucion_id = institucion_id;
        this.persona_id = persona_id;
        this.categoria_id = categoria_id;
        this.seccion_id = seccion_id;
        this.cargo_id = cargo_id;
        this.clase = clase;
        this.personal_temporario = personal_temporario;
        this.discapacidad = discapacidad;
        this.situacion_revista_id = situacion_revista_id;
        this.fecha_ingreso = fecha_ingreso;
        this.fecha_egreso = fecha_egreso;
        this.fecha_ingreso_reconocida = fecha_ingreso;
        this.sindicato_id = sindicato_id;
        this.regimen_jubilatorio_id = regimen_jubilatorio_id;
        this.obra_social_id = obra_social_id;
        this.modalidad_contratacion_id = modalidad_contratacion_id;
        this.forma_pago = forma_pago;
        this.banco = banco;
        this.lugar_trabajo = lugar_trabajo;
        this.lugar_pago = lugar_pago;
        this.aporta_minimo = aporta_minimo
    }
}
export default Legajo;